<template>
    <div v-on:click="onClick($event, isLeft)" v-on:mouseenter="onMouseEnter" v-on:mousemove="onMouseMove" v-on:mouseleave="onMouseLeave" >
        <slot></slot>

        <div ref="cursor" v-bind:class="{ 'is-active': isActive }" class="c-cursor-follow u-absolute u-pos-tl">
            <slot name="cursor"></slot>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import getPrefix from '@/utilities/getPrefix';
    import getOffsets from '@/utilities/getOffsets';

    export default {
        name: 'cursorFollow',

        props: {
            onClick: { type: Function, default: () => this },
            initX: { type: Number, default: 0.5 },
            initY: { type: Number, default: 0.5 },
            reposition: { type: Boolean, default: false },
            sticky: { type: Boolean, default: false },
            autoHide: { type: Boolean, default: false },
        },

        data() {
            return {
                isActive: false,
                isLeft: false,
            };
        },

        computed: {
            ...mapState('window', [
                'isTouch'
            ])
        },

        created() {
            this.x = 0;
            this.targetX = 0;

            this.y = 0;
            this.targetY = 0;
        },

        mounted() {
            if (!this.autoHide) {
                this.isActive = true;
            }

            this.resize();

            this.x = this.targetX = this.posInit.x;
            this.y = this.targetY = this.posInit.y;

            this.$eventHub.$on('resize', this.resize);
            this.$eventHub.$on('update', this.update);
        },

        beforeDestroy() {
            this.$eventHub.$off('resize', this.resize);
            this.$eventHub.$off('update', this.update);
        },

        methods: {
            resize() {
                this.offsets = getOffsets(this.$el);
                this.width = this.$el.offsetWidth;
                this.height = this.$el.offsetHeight;

                this.cursorWidth = this.$refs.cursor.offsetWidth;
                this.cursorHeight = this.$refs.cursor.offsetHeight;

                this.posInit = {
                    x: this.width * this.initX,
                    y: this.height * this.initY,
                };
            },

            onMouseEnter() {
                this.isActive = true;
            },

            onMouseMove(event) {
                if(this.isTouch) return;

                this.pointerEvent = this.isTouch && event.type != 'mousemove' ? (event.touches[0] || event.changedTouches[0]) : event;

                if (!this.sticky) {
                    this.targetX = this.pointerEvent.pageX - this.offsets.left;
                    this.targetY = this.pointerEvent.pageY - this.offsets.top;
                } else {
                    this.targetX = this.pointerEvent.clientX - this.offsets.left;
                    this.targetY = this.pointerEvent.clientY - this.offsets.top;
                }

                if (this.slider) {
                    this.isLeft = (this.pointerEvent.pageX < this.offsets.left + this.width / 2);
                }
            },

            onMouseLeave() {
                if(this.isTouch) return;

                if (this.autoHide) {
                    this.isActive = false;
                }

                if (this.reposition) {
                    this.targetX = this.posInit.x;
                    this.targetY = this.posInit.y;
                }
            },

            update() {
                this.x += (this.targetX - this.x) * 0.1;
                this.y += (this.targetY - this.y) * 0.1;

                this.$refs.cursor.style[getPrefix('transform')] = `translateX(${this.x}px) translateY(${this.y}px) translateZ(0)`;
            },
        },
    }
</script>

<style lang="stylus">
    @import '../styles/settings/*'

    .c-cursor-follow {
        pointer-events none

        opacity 0
        transform translateZ(0)
        transition opacity 0.4s $ease-out-quart

        &.is-active {
            opacity 1
        }
    }
</style>
